import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-155a0442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "passwordInput" }
const _hoisted_2 = {
  key: 0,
  title: "Required Field"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - Optional field")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("abbr", null, "*", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["type", "name", "placeholder", "maxlength", "pattern", "autofocus", "disabled", "readonly", "required", "autocomplete"]
const _hoisted_8 = {
  key: 2,
  class: "conditions"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Numbers present ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" No Spaces ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Capital Letter ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Snall letters ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" More than 8 characters ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Special character ")
const _hoisted_15 = {
  key: 0,
  title: "Required Field"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" - Optional field")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("abbr", null, "*", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = ["type", "name", "placeholder", "maxlength", "autofocus", "disabled", "readonly", "autocomplete"]
const _hoisted_21 = {
  key: 2,
  class: "conditions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_response = _resolveComponent("input-response")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ inline: _ctx.inline })
    }, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass({ maskField: _ctx.mask })
          }, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("abbr", _hoisted_2, "*"))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_6))
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
					warningContainer: _ctx.alert ? _ctx.alert.warning : false,
					errorContainer: _ctx.alert ? _ctx.alert.error : false,
					iconPadding: _ctx.icon,
					maskField: _ctx.mask
				})
      }, [
        (_ctx.icon)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(_ctx.icon)
            }, null, 2))
          : _createCommentVNode("", true),
        (!_ctx.mask)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dValue) = $event)),
              type: _ctx.dType,
              name: _ctx.name,
              placeholder: _ctx.placeholder,
              maxlength: _ctx.maxlength,
              pattern: _ctx.pattern,
              autofocus: _ctx.autofocus,
              disabled: _ctx.disabled,
              readonly: _ctx.readonly,
              required: _ctx.required,
              autocomplete: _ctx.autocomplete,
              "onKeyup[0]": _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ctx && _ctx.ctx(...args))),
              "onKeyup[1]": _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ctx && _ctx.ctx(...args))),
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
              onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.followsPattern && _ctx.followsPattern(...args)))
            }, null, 40, _hoisted_7)), [
              [_vModelDynamic, _ctx.dValue]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass(['fas', _ctx.dType != 'text' ? 'fa-eye' : 'fa-eye-slash']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.peek(true)))
        }, null, 2),
        (_ctx.dValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(
								_ctx.dValue.match(/(?=.*[A-Z])(?=.*[0-9])/g)
									? 'fas fa-check'
									: 'fas fa-times'
							)
                }, null, 2),
                _hoisted_9
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.dValue.match(/\S{1,}/g) ? 'fas fa-check' : 'fas fa-times')
                }, null, 2),
                _hoisted_10
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(
								_ctx.dValue.match(/(?=.*[A-Z])/g) ? 'fas fa-check' : 'fas fa-times'
							)
                }, null, 2),
                _hoisted_11
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(
								_ctx.dValue.match(/(?=.*[a-z])/g) ? 'fas fa-check' : 'fas fa-times'
							)
                }, null, 2),
                _hoisted_12
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.dValue.length > 7 ? 'fas fa-check' : 'fas fa-times')
                }, null, 2),
                _hoisted_13
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(
								_ctx.dValue.match(/(?=.*[!@#\\$%\\^&\\*])/g)
									? 'fas fa-check'
									: 'fas fa-times'
							)
                }, null, 2),
                _hoisted_14
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_input_response, {
        warning: _ctx.alert ? _ctx.alert.warning : '',
        error: _ctx.alert ? _ctx.alert.error : '',
        info: _ctx.alert ? _ctx.alert.info : _ctx.dValue ? _ctx.maxlength - _ctx.dValue.length < 0 : '',
        success: _ctx.alert ? _ctx.alert.success : ''
      }, null, 8, ["warning", "error", "info", "success"])
    ], 2),
    (_ctx.valueMatch)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ inline: _ctx.inline })
        }, [
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: _normalizeClass({ maskField: _ctx.mask })
              }, [
                _createTextVNode(" Confirm " + _toDisplayString(_ctx.label) + " ", 1),
                (_ctx.required)
                  ? (_openBlock(), _createElementBlock("abbr", _hoisted_15, "*"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_19))
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({
					warningContainer: _ctx.dValue
						? _ctx.valueMatch
							? _ctx.dValue === _ctx.valueMatch
								? null
								: 'Passwords does not match'
							: null
						: null,
					errorContainer: _ctx.dValue
						? _ctx.valueMatch
							? null
							: 'Required Field'
						: null,
					iconPadding: _ctx.icon,
					maskField: _ctx.mask
				})
          }, [
            (_ctx.icon)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(_ctx.icon)
                }, null, 2))
              : _createCommentVNode("", true),
            (!_ctx.mask)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.valueMatch) = $event)),
                  type: _ctx.dTypeMatch,
                  name: _ctx.name + 'Match',
                  placeholder: _ctx.placeholder,
                  maxlength: _ctx.maxlength,
                  autofocus: _ctx.autofocus,
                  disabled: _ctx.disabled,
                  readonly: _ctx.readonly,
                  autocomplete: _ctx.autocomplete,
                  "onKeyup[0]": _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.ctx && _ctx.ctx(...args))),
                  "onKeyup[1]": _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ctx && _ctx.ctx(...args))),
                  onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
                }, null, 40, _hoisted_20)), [
                  [_vModelDynamic, _ctx.valueMatch]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(['fas', _ctx.dTypeMatch != 'text' ? 'fa-eye' : 'fa-eye-slash']),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.peek(false)))
            }, null, 2),
            (_ctx.dValue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(
								_ctx.dValue && _ctx.dValue === _ctx.valueMatch
									? 'fas fa-check'
									: 'fas fa-times'
							)
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_ctx.label) + " Match ", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_component_input_response, {
            warning: 
					_ctx.dValue
						? _ctx.valueMatch
							? _ctx.dValue === _ctx.valueMatch
								? null
								: 'Passwords does not match'
							: null
						: null
				,
            error: _ctx.dValue ? (_ctx.valueMatch ? null : 'Required Field') : null,
            info: _ctx.alert ? _ctx.alert.info : _ctx.dValue ? _ctx.maxlength - _ctx.dValue.length < 0 : '',
            success: _ctx.alert ? _ctx.alert.success : _ctx.dValue && _ctx.dValue === _ctx.valueMatch
          }, null, 8, ["warning", "error", "info", "success"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}